import React, { useState, useContext, useEffect } from "react"
import { Query } from "react-apollo"
import FavoriteFile from "../components/FavoriteFile"
import FavoriteFolder from "../components/FavoriteFolder"
import Button from "../../../components/Button"
import Modal, { ModalContent, ModalHeader } from "../../../components/Modal"
import CreateNewFolder from "../components/NewFolder"
import { getViewerFolders, getRecentFavorites } from "../queries"
import AppContext from "../../../shared/AppContext"

const RecentlyViewedFavorites = (props) => {
  return (
    <Query query={getRecentFavorites} fetchPolicy="network-only">
      {({ data, error, loading }) => {
        if (error)
          return "An error has occurred while fetching recent favorites."
        if (loading) return "Loading..."
        return (
          <div>
            <div className="section-title">RECENTLY VIEWED FAVORITES</div>
            {!data.searchFavorites.length && (
              <p>No recent favorites to view.</p>
            )}
            <div className="recent-files-container grid files-grid">
              {data.searchFavorites.map((favorite, idx) => {
                return (
                  <FavoriteFile
                    key={idx}
                    className="col"
                    hasMenu={false}
                    favorite={favorite}
                    trackingLocation={`${props.trackingLocation}: Recently Viewed"`}
                  />
                )
              })}
            </div>
          </div>
        )
      }}
    </Query>
  )
}

const FoldersAndFavorites = (props) => {
  return (
    <Query query={getViewerFolders} fetchPolicy="network-only">
      {({ data, error, refetch }) => {
        if (error) return "An error has occurred while fetching user folders."
        if (data && data.viewer) {
          const { folders, unsortedFavorites } = data.viewer

          const noUnsortedFavorites =
            !unsortedFavorites || !unsortedFavorites.length
          const noFolders = !folders || !folders.length

          return (
            <div>
              <div className="section-title">ALL FAVORITES</div>
              <div className="folders-container grid folders-grid">
                {noUnsortedFavorites && noFolders && (
                  <p>No favorites to display.</p>
                )}
                {folders.map((folder, idx) => {
                  const { name, favorites, id, favoriteCount } = folder

                  return (
                    <FavoriteFolder
                      id={id}
                      onViewAllClick={(id) => props.onViewAllClick(id)}
                      key={idx}
                      name={name}
                      count={favoriteCount}
                      favoritesFiles={favorites}
                      refetch={refetch}
                      trackingLocation={props.trackingLocation}
                    />
                  )
                })}
              </div>
              <div className="unsorted-files-container grid files-grid">
                {unsortedFavorites.map((favorite, idx) => {
                  return (
                    <FavoriteFile
                      key={idx}
                      className="col"
                      hasMenu={true}
                      zIndex={0}
                      refetchQuery={refetch}
                      favorite={favorite}
                      trackingLocation={props.trackingLocation}
                    />
                  )
                })}
              </div>
            </div>
          )
        }
        return null
      }}
    </Query>
  )
}

const AddFolderButton = (props) => {
  const buttonOnClickHandler = (modalState) =>
    props.updateModalState(modalState)
  const { trackEvent } = useContext(AppContext)

  return (
    <>
      <Button
        classes={["new-folder-button", "dark-fill"]}
        action={() => {
          buttonOnClickHandler(true)
          trackEvent("New Folder Button Click", {
            location: props.trackingLocation,
          })
        }}
      >
        + New Folder
      </Button>
      <Modal
        isOpen={props.isModalOpen}
        close={() => props.updateModalState(false)}
      >
        <ModalContent style={{ maxWidth: "500px" }}>
          <ModalHeader
            text="Create new folder"
            close={() => props.updateModalState(false)}
          />
          {props.isModalOpen && (
            <CreateNewFolder
              isModalOpen={(modalState) => buttonOnClickHandler(modalState)}
              trackingLocation={props.trackingLocation}
            />
          )}
        </ModalContent>
      </Modal>
    </>
  )
}

const AllFavorites = (props) => {
  const { onViewAllClick, trackingLocation } = props
  const [isModalOpen, updateModalState] = useState(false)
  const { trackPage } = useContext(AppContext)

  useEffect(() => {
    trackPage("My Favorites")
  }, [])

  return (
    <div>
      <RecentlyViewedFavorites trackingLocation={trackingLocation} />
      <FoldersAndFavorites
        onViewAllClick={onViewAllClick}
        trackingLocation={trackingLocation}
      />
      <AddFolderButton
        trackingLocation={trackingLocation}
        isModalOpen={isModalOpen}
        updateModalState={updateModalState}
      />
    </div>
  )
}

export default AllFavorites
